export default __webpack_public_path__ + "static/mollie-859517dae82212f87a22e38def140af9.svg";